import axios from "axios";
import urlConfig from "../../../mixins/url";

export default {
  namespaced: true,
  state: {
    recipes: [],
    recipesTypes: [
      { id: 0, name: "Eko" },
      { id: 1, name: "Konwencja" },
    ]
  },
  mutations: {
    //Synchroniczne
    setChocolateSharpeners(state, data) {
      state.recipes = data;
    },
  },
  actions: {
    //Asyncrhoniczne
    getRecipes(state) {
      var urlRoot = urlConfig.data().url;
      var url = `${urlRoot.serverUrl}${urlRoot.RecipeCoating.GetRecipes}`;

      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((result) => {
            var data = result.data;
            data.forEach((x) => (x.isEdit = false));
            state.commit("setChocolateSharpeners", data);
            resolve({});
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
  },
};
